import { CalendarDays, LayoutGrid, List } from 'lucide-react'

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import type { ListCardsCalendarViewMode } from '@/lib/list-view-mode'
import { cn } from '@/lib/utils'

type ListCardsCalendarViewTabsProps = {
  value: ListCardsCalendarViewMode
  onChange: (mode: ListCardsCalendarViewMode) => void
  className?: string
}

export function ListCardsCalendarViewTabs({
  value,
  onChange,
  className,
}: ListCardsCalendarViewTabsProps) {
  return (
    <Tabs
      value={value}
      onValueChange={(next) => onChange(next as ListCardsCalendarViewMode)}
      className={cn('w-full', className)}
    >
      <TabsList className="grid h-10 w-full max-w-md grid-cols-3 rounded-xl bg-muted/80 p-1">
        <TabsTrigger value="calendar" className="gap-1.5 rounded-lg text-xs sm:text-sm">
          <CalendarDays className="h-4 w-4" />
          Calendar
        </TabsTrigger>
        <TabsTrigger value="list" className="gap-1.5 rounded-lg text-xs sm:text-sm">
          <List className="h-4 w-4" />
          List
        </TabsTrigger>
        <TabsTrigger value="cards" className="gap-1.5 rounded-lg text-xs sm:text-sm">
          <LayoutGrid className="h-4 w-4" />
          Card
        </TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
